import { setGridTableDefaults } from "@homebound/beam";
import { Outlet } from "react-router-dom";
import { RouteEnvironmentProviders } from "src/routing/components/RouteEnvironment";
import { PdfCssReset } from "src/utils/PdfCssReset";

/** Pathless layout for `/pdf/*` pages. Role: data router chrome (no AppShell — headless PDF uses an Authorization header). */
export function PdfLayout() {
  setGridTableDefaults({});
  // Add a margin for when the user is just looking at the page, but remove it for actual pdf generation (ie, printing)
  return (
    <RouteEnvironmentProviders>
      <PdfCssReset />
      <Outlet />
    </RouteEnvironmentProviders>
  );
}
